import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonModal,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import { close } from 'ionicons/icons';
import { useTranslation } from 'react-i18next';
import {
  CuttingPartDetail,
  CuttingPartDetailProps,
} from './cutting-part-detail';

export interface CuttingPartDetailModalProps extends CuttingPartDetailProps {
  isOpen?: boolean;
  onDismiss: () => void;
  presentingEl?: HTMLElement;
}

const CuttingPartDetailModal = (props: CuttingPartDetailModalProps) => {
  const { presentingEl, isOpen, onDismiss } = props;

  const { i18n } = useTranslation();

  return (
    <IonModal
      presentingElement={presentingEl}
      isOpen={isOpen}
      canDismiss={true}
      onDidDismiss={onDismiss}
    >
      <IonHeader>
        <IonToolbar>
          <IonButtons slot={'start'}>
            <IonButton onClick={onDismiss}>
              <IonIcon icon={close} size="large" />
            </IonButton>
          </IonButtons>
          <IonTitle>{i18n.t('common:part_details')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <CuttingPartDetail
          afterSave={() => {
            onDismiss();
          }}
        />
      </IonContent>
    </IonModal>
  );
};

export { CuttingPartDetailModal };
